export default {
  LANGUAGE: {
    NORWEGIAN: 'Norsk',
    ENGLISH: 'Engelsk',
  },
  BACK: 'Tilbake',
  BACK_TO: 'Tilbake til {genreName}',
  CHECK: 'Kontrollér',
  EDIT: 'Rediger',
  GENRE: '{genre}',
  GENRE_WRITE: 'Skriv {genre}',
  GENRE_CHECK: 'Kontrollér {genre}',
  GENRE_SHARE: 'Del {genre}',
  EDITOR: {
    TOOLBAR: {
      BOLD: 'Feit',
      ITALIC: 'Kursiv',
      LIST: 'Punktliste',
      MEDIA: 'Sett inn bilde',
      NORMAL: 'Normal',
      SPEECH_TO_TEXT: 'Les inn tekst',
      TABLE: 'Sett inn tabell',
    },
    TABLE: {
      COLUMNS: {
        LABEL: 'Kolonner',
        ADD: {
          BEFORE: 'Sett inn kolonne til venstre',
          AFTER: 'Sett inn kolonne til høgre',
        },
        REMOVE: 'Fjern kolonne',
      },
      ROWS: {
        LABEL: 'Rader',
        ADD: {
          BEFORE: 'Sett inn rad over',
          AFTER: 'Sett inn rad under',
        },
        REMOVE: 'Fjern rad',
      },
      REMOVE: 'Fjern tabell',
    },
  },
  COLLAPSIBLE: {
    CLOSE: 'Lukk',
  },
  CHECKLIST: {
    TITLE: 'Sjekkliste',
  },
  DISPOSITION: {
    TITLE: 'Verktøy',
    ALT_IMAGE: 'Disposisjon struktur',
    TOOLS: 'Hjelp',
    FILM: 'Film - Korleis skrive {genre}',
    EXAMPLE: 'Eksempel på {genre}',
    AUDIO: 'Lyd - {name}',
  },
  EXAMPLES: {
    TITLE: 'Eksempel på {genre} | Eksempel på {genre}',
    LINK_NAME: 'Eksempel',
  },
  ERROR: {
    NO_ACCESS_TITLE: 'Du har ikkje tilgang til dette produktet',
    NO_ACCESS_MESSAGE: 'Kontakt læraren eller administratoren din for meir informasjon og hjelp.',
  },
  HEADER: {
    TITLE: 'Språk og innlogging',
    MAIN_LANGUAGE: 'Hovudspråk',
    MAIN_LANGUAGE_SUBTEXT: 'Endrar språk i navigasjon og innhald',
    PORTAL: 'Portal',
    DROPDOWN_TOGGLE: 'Topptekst nedtrekksmeny',
    LANG_NB: 'Bokmål',
    LANG_NB_SHORT: 'Bokm.',
    LANG_NN: 'Nynorsk',
    LANG_NN_SHORT: 'Nyno.',
    CLOSE: 'Lukk',
  },

  FOOTER: {
    PRIVACY: 'Personvern',
    CONTACT: 'Kontakt oss',
    COOKIE: 'Informasjonskapslar',
  },

  HOME: 'Framside',
  LOADER: {
    TITLE: 'Lastar',
  },
  SHARE_PAGE: {
    TITLE: 'DEL DOKUMENT',
    DOWNLOAD: {
      PDF: 'LAST NED SOM PDF.',
      WORD: 'LAST NED SOM WORD.',
    },
  },
  ARCHIVE: {
    ZIP_NAME: 'Komprimert mappe',
    PDF_NAME: 'Pdf dokument',
    WORD_NAME: 'Word dokument',
    ATTACHMENT_DIR_NAME: 'Vedlegg',
  },
  LOGIN: 'Logg in',
  LOGOUT: 'Logg ut',
  TASK: 'Oppgåve',
  TASKS: {
    TITLE: 'Oppgåve | Oppgåver',
    LINK_NAME: 'oppgåver',
  },
  SHARE: 'Del',
  VIEW_ALL: 'Sjå alle',
  WRITE: 'Skriv',
  WRITE_STORY: {
    TITLE: 'Skriv {genre}',
    START_NEW: 'Lag ein ny',
    CONTINUE: 'Fortsett på lagra',
  },
  WRITE_PAGE: {
    TIPS: 'Tips',
  },
  EXERCISE: {
    DEFAULT_NAME: 'Dokument utan namn',
    ATTACHMENT_COUNT: 'Vedlegg:',
  },
  SPEECH_TO_TEXT: {
    HEADER: {
      READ_IN: 'Les inn: ',
    },
    START_RECORDING: 'Start opptak no',
    PAUSE_RECORDING: 'Pause',
    LABEL: 'Teksten din:',
    TRANSLATED_LABEL: 'Klargjer teksten:',
    CONTINUE_RECORDING: 'Fortsett på opptak',
    RESET_RECORDING: 'Tilbakestill (start på nytt)',
    ERRORS: {
      DEVICE_NOT_FOUND: 'Finn ikkje mirkofon. Ver vennleg og sjekk systeminnstillingane.',
      PERMISSION_DENIED: 'Får ikkje brukt mikrofonen. Ver vennleg og sjekk nettlesarinnstillingane.',
      UNEXPECTED: 'Det oppstod ein uventa feil. Prøv igjen seinare.',
    },
  },
  TEXT_TO_SPEECH: {
    LISTEN: 'Lytt til teksten',
    ERROR_NOT_ALLOWED: 'Lyden er klar. Spel av for å lytte til teksten.',
    SPEED_LABEL: 'Hastigheit',
    SPEED: {
      SLOWLY: 'Sakte',
      QUICKLY: 'Raskt',
    },
  },
  VIEW: {
    HOME: {
      DESCRIPTION:
        'Dei fleste yrke krev dokumentasjon av arbeid som grunnlag for kvalitetssikring og læring. Dette verktøyet viser korleis du gjer det. Du kan skrive eller lese inn teksten din.',
      GENRES_LABEL: 'Vel sjanger:',
      TITLE: 'Velkommen!',
    },
  },
  ATTACHMENTS: {
    TITLE: 'Vedlegg (valfritt)',
    TEXT: 'Legg ved opptil {maxFiles} filer',
    REMOVE: 'Fjern',
  },
  MODAL: {
    OVERWRITE_DOCUMENT: {
      TITLE: 'Informasjon',
      TEXT: 'Du vil no starte eit nytt dokumet. Tidlegare lagra tekst blir skriven over.',
    },
    UPLOAD: {
      IMAGE: {
        TITLE: 'Last opp bilde',
        TEXT: 'Berre ei fil per opplasting (støtta format er jpeg og png).',
        BUTTON_UPLOAD: 'Last opp bilde',
      },
      ATTACHMENT: {
        TITLE: 'Last opp vedlegg',
        TEXT: 'Legg ved opptil 10 filer (maks storleik er 5MB per fil).',
        BUTTON_UPLOAD: 'Last opp ei eller fleire filer',
      },
      PROGRESS: 'Laster opp, {progress}% fullført',
      FILE_ERROR: 'Filen er over 5MB!',
      FILE_REMOVE: 'Fjern',
      SIZE_ERROR: 'Du må fjerne alle filer over 5MB for å kunne lagre.',
      PORTRAIT_WARN_TITLE: 'OBS!',
      PORTRAIT_WARN_TEXT:
        'Verktøyet roterer ikkje bilete i ståande format frå Mac og iPhone. - Tilrår å velje bilete i liggande format for å unngå problemet.',
      CANCEL: 'Avbryt',
      SAVE: 'Sett inn',
    },
    ERROR: {
      TITLE: 'Feil oppsto',
      TEXT: 'Det oppstod ein uventa feil. Prøv igjen seinare.',
    },
    PRINT_BUTTON: 'Skriv ut',
    EXAMPLE_DETAILS: {
      DISPOSITION: 'Disposisjon',
      DESCRIPTION: 'Klikk for å framheve i eksempelet.',
      HIGHLIGHT: 'Vis i eksempel',
    },
    LOGOUT: {
      TITLE: 'Informasjon',
      TEXT: 'Du vil logge ut av alle produkta dine hos Fagbokforlaget.',
    },
  },
  BUTTON: {
    CANCEL: 'Avbryt',
    INSERT: 'Sett inn',
    START_WRITING: 'OK, start å skrive',
  },
  DOCUMENT_CONTROL: {
    MANAGE: 'Val',
    SAVE_AS: 'Lagre som',
    SAVE: 'Lagre',
    RENAME: 'Endre namn',
    DELETE: 'Slett dokumentet',
    CLOSE: 'Lukk',
  },
  ARIA: {
    CLOSE_MODAL: 'lukk vindu',
    UPLOAD: 'Last opp fil',
    REMOVE_FILE: 'Fjern fil',
    SAVE: 'Lagre',
    CANCEL: 'Avbryt',
    OK: 'OK',
  },
  IMAGE_FIELD: {
    LABEL_NEW: 'Sett in bilde',
    LABEL_UPDATE: 'Endre bilde',
  },

  RENAME_MODAL: {
    TITLE: 'Endre namn:',
    OK: 'Utfør',
    CLOSE: 'Avbryt',
  },

  REMOVE_MODAL: {
    TITLE: 'Slett dokument',
    MESSAGE: 'Er du sikker?',
    DELETE: 'Slett',
    ABORT: 'Avbryt',
  },

  SAVE_AS_MODAL: {
    TITLE: 'Lagre som:',
    OK: 'OK',
    CLOSE: 'Lukk',
  },

  DOCUMENT_MODAL: {
    TITLE: 'Mine dokument',
    DESCRIPTION: 'Her finn du dei lagra dokumenta dine for alle sjangrar.',
    EDIT_BTN: 'Rediger',
    SAVE_BTN: 'Ferdig',
    FILTER_ALL: 'ALLE',
    EMPTY: 'Ingen dokument',
    UNDO_DELETE: 'Angre sletting',
  },
  AUTO_SYNC: {
    TITLE: {
      SUCCESS: 'Blir lagra automatisk',
      ERROR: 'Ikkje nettsamband',
      DEFAULT: 'Lagrar',
    },
    SUBTITLE: {
      SUCCESS: '',
      ERROR: 'Blir lagra når nettet er tilbake',
      DEFAULT: '',
    },
  },

  ALIGN: {
    RIGHT: 'Flytt mot høyre',
    LEFT: 'Flytt mot venstre',
    CENTER: 'Midtstill',
  },

  ADJUST_IMAGE: {
    LABEL: 'Tilpass',
    WIDTH_100: '100% breidde',
    WIDTH_50: '50% breidde',
  },

  SEE_ALL: {
    LINK: 'Vis alle',
    TASKS: 'Alle oppgaver',
    EXAMPLES: 'Alle eksempler',
    TITLE: {
      TASKS: 'Oppgaver',
      EXAMPLES: 'Eksempler',
    },
  },
  ALERT: {
    OFFLINE: {
      TITLE: 'Obs!',
      TEXT: 'Nokre funksjonar verkar ikkje utan internettilkopling.',
      FEATURE_TEXT: 'Denne funksjonen verkar ikkje utan internettilkobling.',
    },
  },
  LOGO: {
    ALT: 'Illustrasjon av grå skiftenøkkel og grøn blyant',
  },
};
